import { toString } from "currency";
import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import { Commission } from "../../../types";
import CardText from "../../CardText";

type Props = {
  breakdown: Commission["breakdown"];
  currency: Commission["currency"];
};

export default function CommissionBreakdown({ breakdown, currency }: Props) {
  const tailwind = useTailwind();

  if (!breakdown.length) {
    return null;
  }

  return (
    <View style={tailwind("mt-4")}>
      <CardText.Subtitle text="Desglose" />
      {breakdown.map(({ text, amount }, index) => (
        <View style={tailwind("flex-row justify-between mt-1")} key={index}>
          <CardText.Body text={text} />
          <CardText.Body text={toString({ amount, currency })} />
        </View>
      ))}
    </View>
  );
}
